import { environment } from '../../../environments/environment';

export class Endpoints {
  public static readonly LIST_RECOMBINATIONS_ENDPOINT: string = environment.baseUrl + 'recoms';
  public static readonly EXCHANGE_CALCULATE_FEE_ENDPOINT: string = environment.baseUrl + 'fees';
  public static readonly EXCHANGE_FEE_SCHEDULE: string = environment.baseUrl + 'fee-schedule';
  public static readonly VALIDATE_EXPANDABLE_EXCHANGE_ENDPOINT: string =
    environment.baseUrl + 'validate-exp-pandi';
  public static readonly LIST_RECOMBINATIONS_AT_TAKEDOWNS_ENDPONT: string =
    environment.baseUrl + 'at-settlement-deals';
  public static readonly LIST_RECOMBINATIONS_AT_SETTLED_EXCHANGES_ENDPONT: string =
    environment.baseUrl + 'settled';
  public static readonly COMMIT_EXCHANGE_SERVICE: string = environment.baseUrl + 'commit';
  public static readonly RETRIEVE_EXCHANGE_SERVICE: string = environment.baseUrl + 'retrieve';
  public static readonly COMMITTED_EXCHANGES_ENDPONT: string = environment.baseUrl + 'committed';
  public static readonly CANCEL_EXCHANGE_ENDPONT: string = environment.baseUrl + 'cancel';
  public static readonly LIST_DEALERS_TRADERS_ENDPOINT: string = environment.baseUrl + 'customers';
  public static readonly GET_USER_DETAILS_ENDPOINT: string = environment.baseUrl + 'userProfile';
  public static readonly DOWNLOAD_EXCHANGE_PDF: string = environment.baseUrl + 'info';
  public static readonly ESSO_LOGOUT_ENDPOINT: string = '/InvestorDirect/logout';
  public static readonly EXCHANGE_SETTLEMENT_DATE_ENDPOINT: string =
    environment.baseUrl + 'settle-date-info';
  public static readonly RCR_VOLUME_REPORT_ENDPOINT: string =
    environment.baseUrl + 'rcr-volume-report';
  public static readonly CONTACT_REPORT_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/contact-details';
  public static readonly VALIDATE_ARM_POOL_OUTPUT_FILES_ENDPOINT: string =
    '/gp7armcollateral/arm-mega/generate';
  public static readonly JUMEGA_REPORT_ENDPOINT: string = '/gp7armcollateral/ju-mega/generate';
  public static readonly TAKEDOWN_RELOAD_SERVICE: string = environment.baseUrl + 'takedown-reload';
  public static readonly NO_TAKEDOWN_FLAG_ENDPOINT: string =
    environment.baseUrl + 'updatetakedownstatus';
  public static readonly UPDATE_BANNER_ENDPOINT: string = environment.awsBaseUrl + 'updatebanner';
}
